import { Lesson } from "@jelly/lesson";
import { task as task01 } from "../../../task/course-02/lesson-17/task-01";
import { task as task02 } from "../../../task/course-02/lesson-17/task-02";
import theory from "./theory";

import {
  component as componentMaleHi3000hz,
  extraContent as extraContentMaleHi3000hz,
} from "./components/principle-01/male-hi-3000-hz";
import {
  component as componentMaleLo500hz,
  extraContent as extraContentMaleLo500hz,
} from "./components/principle-01/male-lo-500-hz";
import {
  component as componentMaleUnfiltered,
  extraContent as extraContentMaleUnfiltered,
} from "./components/principle-01/male-unfiltered";
import {
  component as componentFemaleHi3000hz,
  extraContent as extraContentFemaleHi3000hz,
} from "./components/principle-01/female-hi-3000-hz";
import {
  component as componentFemaleLo500hz,
  extraContent as extraContentFemaleLo500hz,
} from "./components/principle-01/female-lo-500-hz";
import {
  component as componentFemaleUnfiltered,
  extraContent as extraContentFemaleUnfiltered,
} from "./components/principle-01/female-unfiltered";

const lesson: Lesson = {
  id: "ea66c6ff-692d-40de-8981-fbdbaa343afa",
  publicId: "17",
  name: "Speech production",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [
    {
      title: "",
      description:
        "In this principle you can listen to voice fragments recorded in an anechoic room. You can also choose to filter them either with a high-pass filter or a low-pass filter. A high-pass filter lets through all the frequencies above a certain threshold. A low pass-filter does the inverse. Notice that the high pass filtered speech contains mostly voiceless sounds and is quieter. The low-pass filtered speech contains mostly voiced sounds.",
      theory: theory,
      layout: {
        type: "controlsToggleExtraContent",
        options: {
          controls: [
            {
              type: "dropdown",
              items: [
                {
                  name: "Male",
                },
                {
                  name: "Female",
                },
              ],
              options: {
                label: "Voice type",
              },
            },
            {
              type: "dropdown",
              items: [
                {
                  name: "High pass 3 kHz",
                },
                {
                  name: "Low pass 0,5 kHz",
                },
                {
                  name: "Unfiltered",
                },
              ],
              options: {
                label: "Filtering",
              },
            },
          ],
          extraContent: [
            [extraContentMaleHi3000hz, extraContentMaleLo500hz, extraContentMaleUnfiltered],
            [extraContentFemaleHi3000hz, extraContentFemaleLo500hz, extraContentFemaleUnfiltered],
          ],
          components: [
            [componentMaleHi3000hz, componentMaleLo500hz, componentMaleUnfiltered],
            [componentFemaleHi3000hz, componentFemaleLo500hz, componentFemaleUnfiltered],
          ],
        },
      },
    },
    {
      title: `Connect Elements to correct answers.`,
      description: "Connect with lines.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task01.id,
            },
          },
        },
      },
    },
    {
      title: `Voiced sounds in English are produced by:`,
      description: "Select the correct answer.",
      layout: {
        type: "simple",
        options: {
          components: {
            variant: "__task__",
            data: {
              id: task02.id,
            },
          },
        },
      },
    },
  ],
};

export default lesson;
